"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedGlossary = exports.Glossary = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const spa_core_1 = require("@episerver/spa-core");
const just_debounce_it_1 = __importDefault(require("just-debounce-it"));
const react_share_1 = require("react-share");
const copyToClipboard_1 = require("app/utils/copyToClipboard");
const Glossary = (props) => {
    var _a, _b, _c, _d, _e, _f;
    if (props.labelSettings === undefined)
        return react_1.default.createElement(react_1.default.Fragment, null);
    const [glossaryText, setGlossaryText] = (0, react_1.useState)(((_a = props.labelSettings.glossaryOn) === null || _a === void 0 ? void 0 : _a.value) ? (_b = props.labelSettings.glossaryOn) === null || _b === void 0 ? void 0 : _b.value : props.labelSettings.glossaryOn);
    const [buttonStyle, setButtonStyle] = (0, react_1.useState)('');
    const [elOpacity, setElOpacity] = (0, react_1.useState)(1);
    const [showShare, setShowShare] = (0, react_1.useState)(false);
    const [copyText, setCopyText] = (0, react_1.useState)(((_c = props.labelSettings.shareCopy) === null || _c === void 0 ? void 0 : _c.value) || props.labelSettings.shareCopy);
    const shareEl = (0, react_1.useRef)(null);
    const toggleGlossary = (g) => {
        if (props.dispatch) {
            props.dispatch({ type: 'ApplicationStates/SetGlossaryOpen', glossaryOpen: !g });
        }
    };
    let glossaryState = props.glossaryOpen;
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d;
        const glossaryOn = ((_a = props.labelSettings.glossaryOn) === null || _a === void 0 ? void 0 : _a.value) ? (_b = props.labelSettings.glossaryOn) === null || _b === void 0 ? void 0 : _b.value : props.labelSettings.glossaryOn;
        const glossaryOff = ((_c = props.labelSettings.glossaryOff) === null || _c === void 0 ? void 0 : _c.value) ? (_d = props.labelSettings.glossaryOff) === null || _d === void 0 ? void 0 : _d.value : props.labelSettings.glossaryOff;
        setGlossaryText(props.glossaryOpen ? glossaryOff : glossaryOn);
        setButtonStyle(props.glossaryOpen ? 'checked' : '');
        const handleScroll = () => {
            window.screen.width < 860 &&
                document.body.scrollHeight - window.screen.height - 250 < window.scrollY ?
                setElOpacity(0) : setElOpacity(1);
        };
        if (props.useShare || props.useGlossary)
            window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [glossaryState, props.labelSettings]);
    let glossary = react_1.default.createElement(react_1.default.Fragment, null);
    let share = react_1.default.createElement(react_1.default.Fragment, null);
    const checkClickOutside = (e) => {
        if (!shareEl.current.contains(e.target)) {
            setShowShare(false);
            document.removeEventListener('click', checkClickOutside);
        }
    };
    const toggleShare = () => {
        setShowShare(!showShare);
        document.addEventListener('click', checkClickOutside);
    };
    if (props.useGlossary)
        glossary = react_1.default.createElement("div", { className: `col-6 col-md-12 pb-md-4 ${!props.useShare ? 'pt-md-4' : ''} d-flex justify-content-start` },
            react_1.default.createElement("button", { className: `${buttonStyle} d-flex d-md-block align-items-center m-md-auto`, "aria-pressed": buttonStyle === 'checked' ? 'true' : 'false', onClick: (e) => toggleGlossary(props.glossaryOpen) },
                react_1.default.createElement("span", { className: 'toggle m-md-auto mb-md-2 position-relative d-flex order-1 order-md-2' },
                    react_1.default.createElement("span", { id: 'glossary' }),
                    react_1.default.createElement("span", { className: 'slider position-absolute top-0 start-0 end-0 bottom-0' })),
                react_1.default.createElement("span", { className: 'order-2 order-md-1 d-flex ps-3 ps-md-0 justify-content-md-center align-self-baseline btn-text' }, glossaryText)));
    if (props.useShare) {
        share = react_1.default.createElement("div", { className: '' },
            react_1.default.createElement("button", { className: 'share d-flex justify-content-md-center flex-md-wrap', "aria-controls": 'sharearea', onClick: () => toggleShare(), "aria-pressed": showShare ? 'true' : 'false' },
                react_1.default.createElement("span", { className: 'icon-share pb-md-2 fw-bold order-2 order-md-1 d-inline-flex justify-content-md-center ps-3 ps-md-0' }),
                react_1.default.createElement("span", { className: 'order-1 order-md-2 d-inline-flex align-self-baseline btn-text' },
                    react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.labelSettings, field: 'sharePage' }))));
    }
    const debouncedShare = (0, just_debounce_it_1.default)(() => {
        setShowShare(false);
    }, 2000);
    const cancelCloseShare = () => {
        debouncedShare.cancel();
    };
    const clip = () => {
        var _a;
        const url = document ? document.querySelector("meta[property='og:url']").getAttribute("content") : '';
        const copy = (0, copyToClipboard_1.copyToClipboard)({ value: url });
        if (copy) {
            setCopyText((_a = props.labelSettings.shareCopied) === null || _a === void 0 ? void 0 : _a.value);
            setTimeout(() => {
                var _a;
                setCopyText(((_a = props.labelSettings.shareCopy) === null || _a === void 0 ? void 0 : _a.value) || props.labelSettings.shareCopy);
                setShowShare(false);
            }, 2000);
        }
    };
    if (!props.useGlossary && !props.useShare)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return react_1.default.createElement("div", { className: 'position-absolute h-100 end-0' },
        react_1.default.createElement("div", { style: { opacity: elOpacity }, className: 'glossary fixed-bottom sticky-md-top me-0 ms-auto bottom-0 bottom-md-auto top-md-0 px-6 px-md-5 pt-6 pt-sm-7 pt-md-5 pb-6 pb-sm-7 pb-md-0 text-center' },
            react_1.default.createElement("div", { className: 'row pb-md-2' },
                glossary,
                react_1.default.createElement("div", { ref: shareEl, className: `${!props.useGlossary ? 'col-12' : 'col-6'} col-md-12 pb-md-4 d-flex justify-content-end justify-content-md-center` },
                    share,
                    showShare &&
                        react_1.default.createElement("div", { id: 'sharearea', onMouseEnter: cancelCloseShare, onMouseLeave: debouncedShare, className: 'share-stripe px-6 px-md-9 pt-6 pt-md-0 pb-6 pb-md-0 text-center' },
                            react_1.default.createElement("div", { className: 'row align-content-center h-100' },
                                react_1.default.createElement("div", { className: 'col-3 d-flex justify-content-center' },
                                    react_1.default.createElement(react_share_1.FacebookShareButton, { url: document ? document.querySelector("meta[property='og:url']").getAttribute("content") : '', className: "Demo__some-network__share-button" }, ((_d = props.labelSettings.shareFB) === null || _d === void 0 ? void 0 : _d.value) || props.labelSettings.shareFB)),
                                react_1.default.createElement("div", { className: 'col-3 d-flex justify-content-center' },
                                    react_1.default.createElement(react_share_1.TwitterShareButton, { url: document ? document.querySelector("meta[property='og:url']").getAttribute("content") : '' }, ((_e = props.labelSettings.shareTwitter) === null || _e === void 0 ? void 0 : _e.value) || props.labelSettings.shareTwitter)),
                                react_1.default.createElement("div", { className: 'col-3 d-flex justify-content-center' },
                                    react_1.default.createElement(react_share_1.LinkedinShareButton, { url: document ? document.querySelector("meta[property='og:url']").getAttribute("content") : '' }, ((_f = props.labelSettings.shareLinkedIn) === null || _f === void 0 ? void 0 : _f.value) || props.labelSettings.shareLinkedIn)),
                                react_1.default.createElement("div", { className: 'col-3 d-flex justify-content-center' },
                                    react_1.default.createElement("button", { className: 'bg-none border-0 p-0', onClick: () => clip() }, copyText))))))));
};
exports.Glossary = Glossary;
exports.ConnectedGlossary = (0, react_redux_1.connect)((state) => state.ApplicationStates || {})(exports.Glossary);
exports.default = exports.ConnectedGlossary;
